import React, { useState } from "react";

// @ts-ignore - JSX コンポーネント（型定義なし）
import TitleBlock from "../../../components/block/TitleBlock";
import PaymentListItem from "../../../components/list-item/PaymentListItem";
import PaymentYearFilter, {
  PaymentYearSelection,
} from "../../../components/payment-statement/PaymentYearFilter";
import InlineLoading from "../../../components/loading/InlineLoading";
import {
  useGetMyPaymentStatementsQuery,
  PAYMENT_STATUS_CANCELED,
} from "../../../app/services/paymentStatements";
import { useAutoSelectPaymentYear } from "../../../hooks/useAutoSelectPaymentYear";
import { downloadPaymentStatementPdf } from "../../../utils/paymentStatement";

/**
 * マイページ「支払明細書」タブ。
 *
 * 本人の支払明細書を年度フィルター付きで一覧表示し、各行の PDF を
 * ダウンロードできる（旧 Django のクリエイター向けウォレット画面と同等）。
 */
const PaymentDetails: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] =
    useState<PaymentYearSelection>(currentYear);

  const { data, isLoading, error } = useGetMyPaymentStatementsQuery({
    year: selectedYear,
  });

  const statements = data?.data?.payment_requests ?? [];
  const availableYears = data?.data?.available_years ?? [];

  useAutoSelectPaymentYear(availableYears, selectedYear, setSelectedYear);

  const renderBody = () => {
    if (isLoading) {
      return <InlineLoading visible />;
    }
    if (error) {
      return (
        <p className="bodytext-13 u-text-light-gray u-ptb16">
          支払明細書の取得に失敗しました。
        </p>
      );
    }
    if (statements.length === 0) {
      return (
        <div className="u-col u-items-center u-gap8 u-ptb16">
          <span
            className="material-symbols-rounded"
            style={{ fontSize: "48px", color: "var(--soremo-light-gray)" }}
          >
            receipt_long
          </span>
          <p className="bodytext-13 u-text-light-gray">支払明細書はありません</p>
        </div>
      );
    }
    return statements.map((statement) => (
      <PaymentListItem
        key={statement.id}
        applicationDate={statement.application_date}
        paymentDate={statement.settlement_date}
        paymentAmount={statement.amount}
        isPaymentCompleted={statement.is_paid}
        isCancelled={statement.status_type === PAYMENT_STATUS_CANCELED}
        pdfUrl={statement.pdf_url}
        onDownload={() => downloadPaymentStatementPdf(statement)}
      />
    ));
  };

  return (
    <>
      <TitleBlock
        title="支払明細書"
        description="支払明細書をPDFでダウンロードできます。"
      />
      <PaymentYearFilter
        years={availableYears}
        selected={selectedYear}
        onSelect={setSelectedYear}
      />
      {renderBody()}
    </>
  );
};

export default PaymentDetails;
